import { PROVEEDORES } from '../actions/types';

const initialState = {
    listado: [],
    detalles: null,
    perfil: null
};

export default function proveedoresReducer(state = initialState, action) {
    switch (action.type) {
        case PROVEEDORES.BUSCAR:
            return { ...state, listado: action.payload };

        case PROVEEDORES.AGREGAR:
            return { ...state, listado: [action.payload, ...state.listado] };

        case PROVEEDORES.EDITAR:
            return {
                ...state,
                listado: state.listado.map(proveedor =>
                    proveedor._id === action.payload._id ? action.payload : proveedor
                )
            };

        case PROVEEDORES.ELIMINAR:
            return {
                ...state,
                listado: state.listado.filter(proveedor => proveedor._id !== action.payload)
            };

        case PROVEEDORES.DETALLES:
            return { ...state, detalles: action.payload };

        case PROVEEDORES.PERFIL:
            return { ...state, perfil: action.payload };

        case PROVEEDORES.LIMPIAR:
            return { ...state, detalles: null, perfil: null };

        default:
            return state;
    }
}
